import Status from "components/Status";

// Configurações das telas de Tributos (PO1-2729 Estaduais, PO1-2730 Municipais).
// Endpoints e payloads são os mesmos das telas antigas; só a apresentação mudou.

const statusCell = (flag) =>
  Status({
    status: flag ? "Ativo" : "Inativo",
    title: flag ? "Ativo" : "Inativo",
  });

export const TAX_RATES_STATE_CONFIG = {
  slug: "tributos-estaduais",
  eyebrow: "Impostos",
  title: "Tributos Estaduais",
  description:
    "Alíquotas de ICMS e ISS por transportadora, UF de origem e destino do embarcador selecionado. Baixe a planilha, ajuste e envie de volta.",
  urls: {
    list: "/embarcadores/tributos-estaduais",
    exportCsv: "/embarcadores/tributos-estaduais/export-csv",
    importCsv: "/embarcadores/tributos-estaduais/import-csv",
    update: (id) => `/embarcadores/tributos-estaduais/${id}`,
  },
  editFields: [
    { key: "aliquotaICMS", label: "Alíquota ICMS (%)", type: "percent" },
    { key: "aliquotaISS", label: "Alíquota ISS (%)", type: "percent" },
    { key: "tomadorContribuinte", label: "Tomador Contribuinte", type: "boolean", trueLabel: "Sim", falseLabel: "Não" },
    { key: "status", label: "Status", type: "boolean", trueLabel: "Ativo", falseLabel: "Inativo" },
  ],
  exportFileName: "tributos-estaduais.csv",
  searchLabel: "Buscar tributo",
  searchHint: "Transportadora, UF ou modal",
  searchPlaceholder: "Digite a transportadora, a UF ou o modal",
  searchKeys: ["transportadora", "estadoOrigem", "estadoDestino", "modal"],
  filters: [
    { key: "modal", label: "Modal" },
    { key: "estadoOrigem", label: "UF Origem" },
    { key: "estadoDestino", label: "UF Destino" },
    { key: "status", label: "Status", boolean: true },
  ],
  columns: [
    { key: "modal", label: "Modal" },
    { key: "transportadora", label: "Transportadora" },
    { key: "estadoOrigem", label: "UF Origem" },
    { key: "estadoDestino", label: "UF Destino" },
    { key: "aliquotaICMS", label: "Alíquota ICMS", align: "right" },
    { key: "aliquotaISS", label: "Alíquota ISS", align: "right" },
    {
      key: "tomadorContribuinte",
      label: "Tomador Contribuinte",
      render: (row) => statusCell(Boolean(row.tomadorContribuinte)),
      sortValue: (row) => (row.tomadorContribuinte ? 1 : 0),
    },
    {
      key: "status",
      label: "Status",
      render: (row) => statusCell(Boolean(row.status)),
      sortValue: (row) => (row.status ? 1 : 0),
    },
  ],
};

export const TAX_RATES_COUNTY_CONFIG = {
  slug: "tributos-municipais",
  eyebrow: "Impostos",
  title: "Tributos Municipais",
  description:
    "Alíquotas de ISS por município do embarcador selecionado. Baixe a planilha, ajuste e envie de volta.",
  urls: {
    list: "/embarcadores/tributos-municipais",
    exportCsv: "/embarcadores/tributos-municipais/export-csv",
    importCsv: "/embarcadores/tributos-municipais/import-csv",
    update: (id) => `/embarcadores/tributos-municipais/${id}`,
  },
  editFields: [
    { key: "aliquotaISS", label: "Alíquota (%)", type: "percent" },
    { key: "status", label: "Status", type: "boolean", trueLabel: "Ativo", falseLabel: "Inativo" },
  ],
  exportFileName: "tributos-municipais.csv",
  searchLabel: "Buscar tributo",
  searchHint: "Cidade, UF ou modal",
  searchPlaceholder: "Digite a cidade, a UF ou o modal",
  searchKeys: ["cidade", "uf", "modal"],
  filters: [
    { key: "modal", label: "Modal" },
    { key: "uf", label: "UF" },
    { key: "status", label: "Status", boolean: true },
  ],
  columns: [
    { key: "modal", label: "Modal" },
    { key: "uf", label: "UF" },
    { key: "cidade", label: "Cidade" },
    { key: "aliquotaISS", label: "Alíquota (%)", align: "right" },
    {
      key: "status",
      label: "Status",
      render: (row) => statusCell(Boolean(row.status)),
      sortValue: (row) => (row.status ? 1 : 0),
    },
  ],
};
